module.exports = __webpack_public_path__ + "media/images/landing/fliist-logo-2ce3abeb706724fa576eda1f49a3cd91.png";